import { useEffect, useState } from "react";
import { useForm } from 'react-hook-form'

import Modal from '../Modal';
import { subtaskStatusEnum } from "../../services/EnumsService";
import { createSubtask } from "../../api/tasks.api";
import { getSubtask, updateSubtask } from "../../api/subtask.api";
import { showSuccess, showError } from "../../services/toastServices";
import { CategoryData } from "../../pages/Category/CategoryWrapper";

export function SubtaskModal({ task, subtaskId, closeAction }) {
    const { register, handleSubmit, formState: { errors }, setValue, control } = useForm();
    const[subtask, setSubtask] = useState({})
    const {category, refreshProjectsCategory} = CategoryData();

    const getSubtaskError = error => {
        setSubtask({})
        showError(`Error al recuperar la subtarea. ${error.message}`)
    }

    useEffect(() => {
        async function loadSubtask() {
            if(subtaskId){
                const res = await getSubtask(subtaskId,getSubtaskError)
                setSubtask(res.data)
                setValue('name', res.data.name)
                setValue('description', res.data.description)
                setValue('status', subtaskStatusEnum(res.data.status).shortStatus)
            }
        }
   
        loadSubtask()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        closeAction()
    };

    const actionBar = (
        <div className="flex">
            <button className=' bg-blue-400 rounded-md block w-10 hover:bg-blue-500' onClick={handleClose}>X</button>
        </div>
    )
    const renderHeader = () => {
        if(task){
            return(<h1 className='font-bold text-2xl'>{task.name} - Agregar una subtarea</h1>)
        }else{
            return(<h1 className='font-bold text-2xl'>Editar una subtarea</h1>)
        }
    }
    

    const handleSave = handleSubmit(async data => {
        if(task && task.id){
            const payload = {
                name: data.name,
                description: data.description,
            }
    
            await createSubtask(task.id, payload, createSubtaskSuccess, createSubtaskError)
        }
    })
    const handleUpdate = handleSubmit(async data => {
        if(subtaskId){
            const payload = {
                name: data.name,
                description: data.description,
            }
    
            await updateSubtask(subtaskId, payload, updateSubtaskSuccess, updateSubtaskError)
        }
    })

    const createSubtaskSuccess = (res => {
        showSuccess('Subtarea creada')
        refreshProjectsCategory(category)
        handleClose()
    })

    const createSubtaskError = (error => {
        showError(`Error al crear la subtarea. ${error.message}. ${error.response.data}`)
    })

    const updateSubtaskSuccess = (res => {
        showSuccess('Subtarea actualizada')
        refreshProjectsCategory(category)
        handleClose()
    })

    const updateSubtaskError = (error => {
        showError(`Error al actualizar la subtarea. ${error.message}. ${error.response.data}`)
    })

    const renderButton = () => {
        if(!subtaskId)
            return(<button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleSave}>Crear</button>)
        else
            return(<button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleUpdate}>Actualizar</button>)
    }

    const modal = <Modal onClose={handleClose} actionBar={actionBar} header={renderHeader} modalSize={'52'}>
        <div className='mt-3 grid grid-cols-3 '>
            <div className='col-span-3 ml-2'>
                <form action="" >
                    <input
                        type="text"
                        placeholder="Nombre"
                        {...register("name", { required: true })}
                        className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
                    />
                    {errors.name && <span>Campo requerido</span>}

                    <textarea
                        rows="3"
                        placeholder="Descripción"
                        {...register("description", { required: false })}
                        className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
                    />
                    {errors.description && <span>Campo requerido</span>}
                </form>

                {renderButton()}
            </div>
        </div>
    </Modal>

    return (
        <div>
            {modal}
        </div>
    )
}